import styled from "styled-components";

export const SidebarBlock = styled.div`
  width: 100px;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background-color: var(--surface);
  padding: 40px 0 0 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: visible;

  /* Must stay in lockstep with ContentBlock's margin (Layout/styled.js), the
     mobile burger bar (dashboardHeader/styled.js), and MobileMenuRoot — all at
     768px. A wider hide point left 769-1024px viewports with no nav at all. */
  @media (max-width: 768px) {
    display: none;
  }
`;

export const TopBlock = styled.div`
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MiddleBlock = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(20px, 5vh, 50px);
  margin-top: clamp(20px, 8vh, 100px);
`;

export const BottomBlock = styled.div`
  margin-bottom: clamp(20px, 8vh, 60px);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const MenuItem = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;

  svg path {
    transition: fill 0.2s ease;
  }

  &:hover svg path {
    fill: rgba(25, 118, 210, 1);
    color: rgba(25, 118, 210, 1);
    background-color: rgba(25, 118, 210, 1);
  }

  &:hover > [role="tooltip"],
  &:focus-visible > [role="tooltip"] {
    opacity: 1;
    visibility: visible;
    transform: translate(0, -50%);
  }

  &:hover .sidebar-stroke-icon,
  &:focus-visible .sidebar-stroke-icon {
    color: rgba(25, 118, 210, 1);

    path {
      fill: none;
      stroke: currentColor;
      background: none;
    }
  }

  ${({ $isActive }) =>
    $isActive &&
    `
      svg path {
        fill: rgba(25, 118, 210, 1);
        color: rgba(25, 118, 210, 1);
        background-color: rgba(25, 118, 210, 1);
      }
    `}
`;

export const IconWrapper = styled.div`
  width: 46px;
  height: 46px;
  display: flex;
  position: relative;

  svg {
    margin: auto;
  }

  html[data-theme="dark"] & {
    color: var(--text-secondary);

    ${({ $preserveColors }) =>
      !$preserveColors &&
      `
        svg path {
          stroke: currentColor;
        }
      `}
  }
`;

// Live unread count on the Conversations nav icon.
export const NavBadge = styled.span`
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: #ff4d4f;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  pointer-events: none;
`;

export const TitleTooltip = styled.div`
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 52px;
  z-index: 20;
  min-height: 40px;
  padding: 7px 11px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-left: 0;
  border-radius: 0 14px 14px 0;
  box-shadow: 10px 8px 24px rgba(17, 31, 50, 0.12);
  font-family: var(--font-ui);
  font-weight: 500;
  font-size: 18px;
  line-height: 145%;
  color: rgba(25, 118, 210, 1);
  display: flex;
  align-items: center;
  gap: 10px;
  opacity: 0;
  visibility: hidden;
  transform: translate(-8px, -50%);
  transition:
    opacity 0.18s ease,
    transform 0.18s ease,
    visibility 0.18s ease;
  pointer-events: none;
  white-space: nowrap;
`;
